<div
  class="progress progress--sm"
  role="progressbar"
  aria-label="onboarding_progressbar"
  [attr.aria-valuenow]="progressBar"
  aria-valuemin="0"
  aria-valuemax="100"
>
  <!-- Progress Bar -->
  <div class="progress-bar" [ngStyle]="{ 'width': progressBar + '%' }"></div>
  <div class="progress__steps d-flex justify-content-between">
    @for (item of position; track item.name) {
      <ng-container>
        <div class="progress__item" [ngClass]="'progress__item' + (item?.circle || '')">
          <p class="progress__info">
            <span
              class="break"
              [ngClass]="{
                'progress-steps__item-info': item?.circle === '--active',
              }"
              >{{ item?.name }}</span
            >
          </p>
        </div>
      </ng-container>
    }
  </div>
</div>
